import React from 'react'

import Hero from './components/Hero'
import Button from './components/Button'
import CtaBlock from './components/CtaBlock'
import Icon from './components/Icon'
import Diamonds from './components/Diamonds'
import StickyTape from './components/StickyTape'
import VideoGrid from './components/VideoGrid'
import Video from './components/Video'
import Timeline from './components/Timeline'

const Careers = () => {
  return (
    <>
      <Video />
      <StickyTape />
      <CtaBlock otherChildren={<Diamonds />}>
        <h2>The Best Journeys Start Here.</h2>
        <h3>
          People, talent, teamwork, culture. At Citygate, we’re driven by many
          things, but they all revolve around you.
        </h3>
        <p>
          We’re dedicated to your progression, growth and success. In fact, our
          business is built on people like you and we don’t ever take that for
          granted. That’s why we continually invest in training, development and
          more – to help our people be the best they can be.
        </p>
        <p>
          As you can tell, we’re all about moving careers forward. But it
          doesn’t stop there. By working with leading brands within the exciting
          and innovative automotive space, you can help drive our industry as we
          prepare for a future of electrifying change.
        </p>
        <div className="button-wrapper">
          <Button
            variant="primary"
            href="http://citygate.co.uk/citygate-values"
          >
            Find out more
          </Button>
        </div>
      </CtaBlock>
      <VideoGrid />
      <CtaBlock flipped>
        <Icon />
        <h2>The Citygate Academy</h2>
        <h3>Committed to training and development.</h3>
        <p>
          We’re focused on helping you drive your career forward. That’s why all
          employees can benefit from the purpose built Citygate Automotive
          Academy. Whether it’s brand or product training, mastering the
          exciting world of electric vehicles or role specific support, your
          future starts now.
        </p>
        <div className="button-wrapper">
          <Button variant="primary" href="http://citygate.co.uk/academy">
            Find out more
          </Button>
        </div>
      </CtaBlock>
      <Hero>
        <h2>Our Journey To Date</h2>
        <h3>The start of something special.</h3>
        <p>
          Citygate is founded on a simple vision: “to grow a business we are
          proud of through a commitment to excellence”. As a privately owned and
          friendly family-run business, we’re welcoming, inclusive, have a great
          team ethic and have worked hard to create a positive working
          environment that we can all be proud of. We’d love it if you could be
          part of our story.
        </p>
        <Button
          variant="secondary"
          href="https://citygate.co.uk/citygate-our-journey"
        >
          Find out more
        </Button>
        <Timeline />
      </Hero>
      <Hero
        id="careers-hero"
        key="careers-hero"
        image={`https://media.auto.works/original/8f2d3b70ce02c5b9e3c6ce8d519fbdac:161cceeedf25f4b0622092c2971d48ed`}
      >
        <h2>Join Our Team</h2>
        <Button variant="white" href="https://careers.citygate.co.uk/jobs">
          See All Opportunities
        </Button>
      </Hero>
    </>
  )
}

export default Careers
